export interface AudioFileData {
  urlPart: string;
  uuid: string;
}

export interface GlobalAudioPlayerData {
  fileList: AudioFileData[];
  activeUuid: string;
}

export interface GlobalAudioPlayerFileState {
  uuid: string;
  isPlay: boolean;
  currentTime: number;
  formattedRemainingTime: string;
}

export enum GlobalAudioPlayerActions {
  TOGGLE_AUDIO = "toggleAudio",
  SET_TIME = "setTime",
  PAUSE = "pause",
}

export interface GlobalAudioPlayerActionData {
  name: GlobalAudioPlayerActions;
}

export interface GlobalAudioPlayerActionToggle extends GlobalAudioPlayerActionData {
  name: GlobalAudioPlayerActions.TOGGLE_AUDIO;
  uuid: string;
}

export interface GlobalAudioPlayerActionSetTime extends GlobalAudioPlayerActionData {
  name: GlobalAudioPlayerActions.SET_TIME;
  uuid: string;
  time: number;
}

export interface GlobalAudioPlayerActionPlay extends GlobalAudioPlayerActionData {
  name: GlobalAudioPlayerActions.PAUSE;
}

export type GlobalAudioPlayerAction =
  | GlobalAudioPlayerActionSetTime
  | GlobalAudioPlayerActionToggle
  | GlobalAudioPlayerActionPlay;
